// Logos der Parto Marken. Auf hellen Flächen positiv, im Dunkelmodus und auf Parto Deep negativ.
// tone: "auto" (folgt Hell/Dunkel), "light" (immer positiv), "dark" (immer negativ).
const FILES = {
    parto: "parto-logo",
    "parto solution": "parto-logo",
    hubparto: "hubparto-logo",
    "parto assets": "partoassets-logo",
    partoassets: "partoassets-logo",
    buyparto: "buyparto-logo",
};

export const hasBrandLogo = (name = "") => Boolean(FILES[name.toLowerCase()]);

const BrandLogo = ({ name, tone = "auto", className = "h-7", decorative = false }) => {
    const file = FILES[(name || "").toLowerCase()];
    // decorative: Name steht schon als Text daneben, dann liest der Screenreader ihn nicht doppelt
    const alt = decorative ? "" : name;
    if (!file) return null;
    const pos = `/brand/${file}-positiv.svg`;
    const neg = `/brand/${file}-negativ.svg`;
    if (tone === "light") return <img src={pos} alt={alt} className={`w-auto ${className}`} />;
    if (tone === "dark") return <img src={neg} alt={alt} className={`w-auto ${className}`} />;
    return (
        <>
            <img src={pos} alt={alt} className={`w-auto dark:hidden ${className}`} />
            <img src={neg} alt={alt} className={`w-auto hidden dark:block ${className}`} />
        </>
    );
};

export default BrandLogo;
